import { useTheme } from "styled-components";
import useClassicScrollView from "common/Scroll/useClassicScrollView";
import useNewLookScrollView from "common/Scroll/useNewLookScrollView";

interface ScrollViewOptions {
  onRefresh?: () => void;
  refreshing?: boolean;
  loading?: boolean;
  ignoreExternalRefreshing?: boolean;
}

const useScrollView = (options: ScrollViewOptions) => {
  const { isNewLook } = useTheme();
  const classic = useClassicScrollView(isNewLook ? {} : options);
  const newLook = useNewLookScrollView(isNewLook ? options : {});
  if (isNewLook)
    return {
      ...newLook,
      spinnerProps: { look: "newLook" as const, ...newLook.spinnerProps },
    };
  return {
    ...classic,
    spinnerProps: { look: "classic" as const, ...classic.spinnerProps },
  };
};

export default useScrollView;
